import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleResolvedChallengeBoardDistribution } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBoardDistributionDisplayFromDefinition } from '~/boggle/config/boardDistributions/formatResolvedBoardDistributionDisplay'

export const oopsAllEsBoardDistributionDefinition: BoggleChallengeBoardDistributionDefinition = {
  description: 'All vowels are replaced with E',
  id: 'oops-all-es',
  name: "Oops, All E's",
  parameterDefinitions: {
    replacementVowel: {
      kind: 'enum',
      max: 0,
      min: 0,
      values: ['E'],
    },
  },
  selectionWeight: 1,
  shortLabel: 'Vowels -> E',
}

export function resolveOopsAllEsBoardDistribution(
  family: BoggleChallengeBoardDistributionDefinition,
  rngState: number,
): {
  mod: BoggleResolvedChallengeBoardDistribution
  rngState: number
} {
  const parameters = {
    replacementVowel: {
      definition: family.parameterDefinitions.replacementVowel!,
      value: 'E',
    },
  }
  const display = formatResolvedBoardDistributionDisplayFromDefinition(family, parameters)

  return {
    mod: {
      description: display.description,
      effects: [
        {
          kind: 'letter-weights',
          transform: {
            kind: 'replace-vowels',
            replacement: 'E',
          },
        },
      ],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [
        {
          kind: 'vowel-replacement',
          letter: 'E',
        },
      ],
      parameters,
      shortLabel: display.shortLabel,
    },
    rngState,
  }
}
